module.exports = __webpack_public_path__ + "static/media/icon_heart_full_white.7c8a7605.svg";